module.exports = __webpack_public_path__ + "static/media/IWCF-LOGO.39fdebab.png";